/**
 * This function will return a number with commas
 * e.g. 1000000 -> 1,000,000
 * @param x
 * @returns
 */
export const numberFormattedWithCommas = (x: number): string => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
